/**
 * Утилиты форматирования: даты, времени, относительного времени, телефонных номеров
 */
import { format, formatDistanceToNow } from 'date-fns';
import { ru } from 'date-fns/locale';

/**
 * Проверяет валидность даты
 */
function isValidDate(date: Date): boolean {
  return date instanceof Date && !isNaN(date.getTime());
}

/**
 * Форматирует дату в читаемый формат
 */
export function formatDate(date: Date | string | null | undefined): string {
  if (!date) return '—';
  const d = typeof date === 'string' ? new Date(date) : date;
  if (!isValidDate(d)) return '—';
  return format(d, 'dd.MM.yyyy', { locale: ru });
}

/**
 * Форматирует дату и время
 */
export function formatDateTime(date: Date | string | null | undefined): string {
  if (!date) return '—';
  const d = typeof date === 'string' ? new Date(date) : date;
  if (!isValidDate(d)) return '—';
  return format(d, 'dd.MM.yyyy HH:mm', { locale: ru });
}

/**
 * Форматирует относительное время (например, "2 часа назад")
 */
export function formatRelativeTime(date: Date | string | null | undefined): string {
  if (!date) return '—';
  const d = typeof date === 'string' ? new Date(date) : date;
  if (!isValidDate(d)) return '—';
  return formatDistanceToNow(d, { addSuffix: true, locale: ru });
}

/**
 * Форматирует телефонный номер
 */
export function formatPhone(phone: string): string {
  // Убираем все нецифровые символы
  const cleaned = phone.replace(/\D/g, '');
  
  // Если номер начинается с 7 или 8, форматируем как российский
  if (cleaned.length === 11 && (cleaned.startsWith('7') || cleaned.startsWith('8'))) {
    return `+7 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7, 9)}-${cleaned.slice(9)}`;
  }
  
  return phone;
}

